export const SET_TAB = '@mapSearch/SET_TAB';
export const SET_TAB_VALUE = '@mapSearch/SET_TAB_VALUE';
export const SET_SEARCH_STATE = '@mapSearch/SET_SEARCH_STATE';
//# sourceMappingURL=constants.js.map